import { css } from '@styled/css';
import { Box } from '@styled/jsx';
import { useEffect, useState } from 'react';

import { httpClient } from '../http_client';

type StatusIndicatorProps = {
  pollMs?: number;
};

export default function StatusIndicator({ pollMs = 5000 }: StatusIndicatorProps) {
  const [ok, setOk] = useState<boolean | null>(null);

  useEffect(() => {
    let mounted = true;
    const check = async () => {
      try {
        const res = await httpClient.get('/api/v1/status');
        if (!mounted) return;
        setOk(res.status >= 200 && res.status < 300);
      } catch {
        if (!mounted) return;
        setOk(false);
      }
    };

    void check();
    const id = setInterval(() => {
      void check();
    }, pollMs);
    return () => {
      mounted = false;
      clearInterval(id);
    };
  }, [pollMs]);

  const title =
    ok == null ? 'Checking server...' : ok ? 'Connected to server' : 'Server unreachable';
  const aria = ok == null ? 'checking' : ok ? 'connected' : 'unreachable';
  const bgColor = ok == null ? 'rgba(255,255,255,0.5)' : ok ? '#4ade80' : '#f87171';
  const shadowColor =
    ok == null ? 'transparent' : ok ? 'rgba(74,222,128,0.5)' : 'rgba(248,113,113,0.5)';

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={2}
      cursor="default"
      data-testid="status-indicator"
      aria-label={aria}
      title={title}
    >
      <span
        className={css({
          w: '10px',
          h: '10px',
          borderRadius: 'full',
          transition: 'all 0.3s',
          boxShadow: `0 0 8px ${shadowColor}`,
        })}
        style={{ backgroundColor: bgColor }}
      />
    </Box>
  );
}
